import React, { Component } from "react";

//Common Functions

import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import * as pr from "../../../common/PrimeComponents";
import * as ChartHelper from "../../Statistics/ChartExamples";

//import "./CustomCSS/charts.css";
export class DashboardProducts extends Component {
  constructor() {
    super();
    this.state = {
      products: [
        {
          name: "Product 1",
          numberCreated: "57",
          averageLeadTime: "2 Week(s)"
        },
        {
          name: "Product 2",
          numberCreated: "46",
          averageLeadTime: "1 Week(s)"
        },
        {
          name: "Product 3",
          numberCreated: "27",
          averageLeadTime: "3 Day(s)"
        },
        {
          name: "Product 4",
          numberCreated: "20",
          averageLeadTime: "1 Month(s)"
        },
        {
          name: "Product 5",
          numberCreated: "15",
          averageLeadTime: "2 Month(s)"
        }
      ]
    };
  }

  componentDidMount = () => {
    this.initialDataRender();
  };

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loaded: false, editLoaded: false });

    this.setState({ loaded: true, editLoaded: true });
  };

  // #endregion

  // #region View
  render() {
    return (
      <pr.Panel header={"Top 5 Products"}>
        <pr.DataTable value={this.state.products}>
          <pr.Column field="name" header="Name" />
          <pr.Column field="numberCreated" header="Number Created" />
          <pr.Column field="averageLeadTime" header="Avg Lead Time" />
        </pr.DataTable>
      </pr.Panel>
    );
  }
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/UI/DashboardProducts.js